/* eslint-disable import/extensions */

import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';
import { doBackendRequest } from '~/assets/js/utils/auth-utils.js';
import GOOGLE_ANALYTICS_TRACKING_IDS from '~/assets/constants/google_analytics_config.js';

const callGoogleAnalyticsEndpoint = (trackingId) => {
    const analytics = Analytics({
        app: 'autobahn-app',
        plugins: [
            googleAnalytics({
                trackingId,
            }),
        ],
    });
    analytics.page();
};

const runGoogleAnalyticsWithoutLogin = () => {
    callGoogleAnalyticsEndpoint(GOOGLE_ANALYTICS_TRACKING_IDS.WITHOUT_LOGIN);
};

const runGoogleAnalyticsForNonAdmins = () => {
    doBackendRequest('GET', '/api/is_super_admin', (response) => {
        if (!response.is_super_admin) {
            callGoogleAnalyticsEndpoint(GOOGLE_ANALYTICS_TRACKING_IDS.WITH_LOGIN);
        }
    }, undefined, undefined);
};

const runGoogleAnalytics = () => {
    const path = window.location.pathname;
    const pagesWithoutLogin = ['/', '/signup/', '/login/', '/terms/', '/privacy/'];
    const inPagesWithoutLogin = pagesWithoutLogin.indexOf(path) >= 0;
    if (inPagesWithoutLogin) {
        runGoogleAnalyticsWithoutLogin();
    } else {
        runGoogleAnalyticsForNonAdmins();
    }
};

export default runGoogleAnalytics;
